/**
 * Phonics Letter Cc — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/cc/）
 * 开发环境通过 public/media/phonics/cc/ 访问，生产环境由 NGINX 提供
 */

const MEDIA_BASE = '/media/phonics/cc';
const V = 'v1';

export const letterData = {
  letter: 'C',
  title: 'Phonics',
  subtitle: 'Letter C',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Cc.mp4?${V}`,
    startTime: 12,
    endTime: 89,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image7.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
  ],

  // Step 3: Vocab (dual-videos) → 合并到 storySections
  // Step 4-5: Story (video-top-lines-bottom) → 合并到 storySections
  storySections: [
    // Step 3: Learn the words — where + hear（双视频并排）
    {
      label: 'Learn the words',
      layout: 'dual-videos',
      videos: [
        { src: `${MEDIA_BASE}/video_words1_where.mp4?${V}`, poster: `${MEDIA_BASE}/image11.png?${V}` },
        { src: `${MEDIA_BASE}/video_words1_hear.mp4?${V}`, poster: `${MEDIA_BASE}/image12.png?${V}` },
      ],
      splitAt: 1,
      lines: [
        // left: where
        { en: 'where', cn: '哪里', audioEn: `${MEDIA_BASE}/w_en_where.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_where.mp3?${V}` },
        // right: hear
        { en: 'hear', cn: '听到', audioEn: `${MEDIA_BASE}/w_en_hear.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_hear.mp3?${V}` },
      ],
    },

    // Step 4: Learn the Story (1)
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_camera.mp4?${V}`, poster: `${MEDIA_BASE}/image13.png?${V}` }],
      lines: [
        { en: 'Where is my camera?', cn: '我的相机在哪里？', audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'I hear my camera.', cn: '我听到我的相机。', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
        { en: 'Cat has my camera.', cn: '猫拿了我的相机。', audioEn: `${MEDIA_BASE}/story1_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_3.mp3?${V}` },
      ],
    },

    // Step 5: Learn the Story (2)
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{ src: `${MEDIA_BASE}/video_story_computer.mp4?${V}`, poster: `${MEDIA_BASE}/image14.png?${V}` }],
      lines: [
        { en: 'Where is my computer?', cn: '我的电脑在哪里？', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'I hear my computer.', cn: '我听到我的电脑。', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'Cow has my computer.', cn: '奶牛拿了我的电脑。', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },
  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
